"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_text_1 = require("@hotelplan/components.common.text");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const LayoutWrapper = styled_components_1.default.div(({ theme }) => theme.auth.b2bLoginLayout);
const LayoutBlockWrapper = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ display: 'flex', maxWidth: [null, '485px'] }, theme.auth.loginLayoutBlockStyles)));
const LayoutBlock = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    py: [4, '50px'],
    px: [4, '62px'],
    width: '100%',
    '.text-line-skeleton-wrapper': {
        marginBottom: [4, '25px'],
    },
    '.form-title': theme.auth.formTitleStyles,
    '.form-text': theme.auth.formTextStyles,
}));
const B2BLoginLayout = props => {
    const { mainTitle, mainText, loading, children } = props;
    return (react_1.default.createElement(LayoutWrapper, null,
        react_1.default.createElement(LayoutBlockWrapper, null,
            react_1.default.createElement(LayoutBlock, null,
                loading ? (react_1.default.createElement("div", { className: "text-line-skeleton-wrapper", "data-id": "text-skeleton-wrap" },
                    react_1.default.createElement(components_common_text_1.TextLineSkeleton, { width: 250 }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("h2", { className: "form-title" }, mainTitle),
                    mainText && (react_1.default.createElement("div", { className: "form-text", "data-id": "layout-text", dangerouslySetInnerHTML: {
                            __html: mainText,
                        } })))),
                children))));
};
exports.default = B2BLoginLayout;
//# sourceMappingURL=B2BLoginLayout.js.map